var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsFamilyHomeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 9.25L70.9167 34.6875L67.2167 39.6208L61.6667 35.4583V64.75H12.3333V35.4583L6.78334 39.6208L3.08334 34.6875L37 9.25ZM22.6625 37.1542C22.6625 39.8778 24.1271 42.7812 27.0563 45.8646C29.9854 48.9479 33.3 52.1597 37 55.5C40.7 52.1597 44.0146 48.9479 46.9438 45.8646C49.8729 42.7812 51.3375 39.8778 51.3375 37.1542C51.3375 34.8931 50.5667 33.0174 49.025 31.5271C47.4833 30.0368 45.6333 29.2917 43.475 29.2917C42.1389 29.2917 40.9179 29.562 39.812 30.1026C38.7061 30.6432 37.7688 31.3493 37 32.2208C36.2292 31.3472 35.2662 30.6411 34.1109 30.1026C32.9557 29.564 31.7604 29.2937 30.525 29.2917C28.3667 29.2917 26.5167 30.0368 24.975 31.5271C23.4333 33.0174 22.6625 34.8931 22.6625 37.1542ZM55.5 58.5833V30.8333L37 16.9583L18.5 30.8333V58.5833H55.5Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsFamilyHomeOutline);
export default __webpack_public_path__ + "static/media/material-symbols_family-home-outline.8240a3e1e9a0d2a8713a9faaaf35fe1b.svg";
export { ForwardRef as ReactComponent };